import { deviceMappingListQuerySchema, type DeviceMapping } from '@chukua/common';
import { useListQuery } from '../../../shared/hooks/use-list-query';
import { useToast } from '../../../shared/hooks/use-toast';
import { closeDeviceMapping, listDeviceMappings } from '../integrations.api';
import { apiErrorReason } from '../policies/api-error-reason.policy';
import { usePagedList } from '../../../shared/hooks/use-paged-list';

/** The device mappings list plus ending one (the only edit: a swap ends the old mapping and adds a new one). */
export function useDeviceMappings() {
  const list = useListQuery(deviceMappingListQuerySchema);
  const { state, isRefreshing, reload } = usePagedList(list.query, listDeviceMappings);
  const toast = useToast();

  async function end(mapping: DeviceMapping): Promise<void> {
    try {
      await closeDeviceMapping(mapping.id, new Date().toISOString());
      await reload();
      toast.success(`${mapping.deviceId} unmapped from ${mapping.truckRegistration}`);
    } catch (err) {
      toast.error(apiErrorReason(err, `Couldn't end the mapping for ${mapping.deviceId}`));
    }
  }

  return { list, state, isRefreshing, reload, end };
}
